module.exports = __webpack_public_path__ + "media/images/sample/profile_pic_1-28a2ac5fe282e6d77e67f7d94cc83728.png";